import z from "zod/v4";

export const utmSchema = z
  .object({
    utm_source: z.string(),
    utm_medium: z.string(),
    utm_campaign: z.string(),
  })
  .partial();

type UtmParams = z.infer<typeof utmSchema>;

export function saveUtmParams(params: UtmParams) {
  Object.entries(params).forEach(([key, value]) => {
    if (value) {
      sessionStorage.setItem(key, value);
    }
  });

  if (typeof gtag !== "undefined")
    gtag("set", {
      campaign: {
        name: params.utm_campaign,
        source: params.utm_source,
        medium: params.utm_medium,
      },
    });
}

export function getUtmParams(): UtmParams {
  const entries = Object.keys(utmSchema.shape)
    .map((k) => [k, sessionStorage.getItem(k) ?? undefined])
    .filter(([, v]) => v !== undefined) as Array<[string, string]>;
  return Object.fromEntries(entries) as UtmParams;
}
